import Icon from '../components/Icon.vue'

Icon.register({"binoculars":{"width":512,"height":512,"paths":[{"d":"M192 104H96V56C96 42.7 106.7 32 120 32H168C181.3 32 192 42.7 192 56V104zM416 56C416 42.7 405.3 32 392 32H344C330.7 32 320 42.7 320 56V104H416V56zM0 456C0 469.3 10.7 480 24 480H144C157.3 480 168 469.3 168 456V440H0V456zM88 128C74.7 128 64 138.7 64 152 64 256 0 272 0 416H168V312C168 298.7 178.7 288 192 288V128H88zM344 456C344 469.3 354.7 480 368 480H488C501.3 480 512 469.3 512 456V440H344V456zM216 128V288H296V128H216zM344 416H512C512 272 448 256 448 152 448 138.7 437.3 128 424 128H320V288C333.3 288 344 298.7 344 312V416z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/binoculars.js
// module id = cm0p
// module chunks = 0